/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Price_Period_YearlyInputs */



/**
* | output |
* | --- |
* | "USD / year · billed annually" |
*
* @param {Signup_Price_Period_YearlyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_price_period_yearly = /** @type {((inputs?: Signup_Price_Period_YearlyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Price_Period_YearlyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("USD / an · facturation annuelle")
	if (locale === "de") return /** @type {LocalizedString} */ ("USD / Jahr · jährliche Abrechnung")
	if (locale === "it") return /** @type {LocalizedString} */ ("USD / anno · fatturazione annuale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("USD / год · ежегодная оплата")
	if (locale === "es") return /** @type {LocalizedString} */ ("USD / año · facturación anual")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("USD / 年 · 按年计费")
	if (locale === "ja") return /** @type {LocalizedString} */ ("USD / 年・年払い")
	if (locale === "hi") return /** @type {LocalizedString} */ ("USD / वर्ष · वार्षिक बिलिंग")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("USD / ano · faturação anual")
	return /** @type {LocalizedString} */ ("USD / year · billed annually")
});